import api from './api.services'
import Bugsnag from '@bugsnag/js'

export const log = async (payload: string) => {
  console.log(payload)
  try {
    await api.auth.logString({ string: payload })
  } catch (e: any) {
    // It's fine if this fails.
    /*Bugsnag.notify(new Error('log error'), function (event) {
      event.context = 'log'
      event.addMetadata('error', {
        error: e,
        logMessage: payload,
      })
      event.addMetadata('log', {
        message: payload,
      })
    })*/
  }
}
